import React, { useState, useEffect } from 'react';
import { SdmTypography } from '.';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

export const SdmCountdownRedirect = ({
  callback,
  isActive = false,
  ...rest
}) => {
  const [countdown, setCountdown] = useState(5);
  const [countdownInterval, setCountdownInterval] = useState();

  const intl = useIntl();
  const i18n = translations.components(intl).countdownRedirect;

  useEffect(() => {
    if (isActive && !countdownInterval) {
      const _countdownInterval = setInterval(() => {
        if (countdown >= 1) setCountdown((ex) => --ex);
      }, 1000);
      setCountdownInterval(_countdownInterval);
    }
    return () => {
      if (countdownInterval) clearInterval(countdownInterval);
    };
  }, [isActive]);

  useEffect(() => {
    if (countdown === 0) {
      clearInterval(countdownInterval);
      setCountdownInterval(null);
      callback && callback();
    }
  }, [countdown]);

  const getMessage = () => {
    const countdownMessage = i18n.message.replace(
      '##COUNTDOWN##',
      `${countdown}`
    );
    return countdownMessage;
  };

  return (
    <div>
      <SdmTypography {...rest}>{getMessage()}</SdmTypography>
    </div>
  );
};
